import React from 'react';
import CKEditor from '../ReactCKEditor';
import { CKEditorEvent } from 'src/types/types';

type eventFn = (ckEvent: CKEditorEvent) => void;

interface XplorActiveNewsBodyEditorProps {
  name?: string;
  events?: Record<string, eventFn>;
  config?: Record<string, unknown>;
  content?: string;
}
const themeStyleSheets = {
  dark: `${process.env.REACT_APP_XPLOR_ACTIVE_BASE_URL}/members/v2/app_spaces/xplor/css/news_dark.css`,
  light: `${process.env.REACT_APP_XPLOR_ACTIVE_BASE_URL}/members/v2/app_spaces/xplor/css/news_light.css`,
};

const XplorActiveNewsBodyEditor: React.FC<XplorActiveNewsBodyEditorProps> = ({
  name = 'xplaNewsEditor',
  content = '',
  config = {},
  events = {},
}) => (
  <CKEditor
    name={name}
    config={{
      removePlugins: 'colorbutton,elementspath',
      removeButtons:
        'Underline,Subscript,Superscript,Anchor,About,Copy,Paste,PasteText,PasteFromWord,Cut,Scayt,Styles',
      extraPlugins: 'strinsert,uploadimage,switchMode',
      imageUploadUrl: `${process.env.REACT_APP_API_BASE_URL}/storedfile/fileUpload/`,
      filebrowserImageUploadUrl: `${process.env.REACT_APP_API_BASE_URL}/storedfile/fileUpload/`,
      enterMode: 2,
      allowedContent: true,
      themeStyleSheets,
      mode: 'light',
      ...config,
    }}
    events={{
      fileUploadRequest: event => {
        const { xhr, file, fileName } = event.data.fileLoader;
        const smStore = JSON.parse(sessionStorage.getItem('sm-store'));
        xhr.setRequestHeader('Authorization', `Bearer ${smStore.security.access_token}`);
        xhr.setRequestHeader(
          'X-User-Club-Id',
          `/${smStore.client}/clubs/${sessionStorage.getItem('club')}`
        );

        const networknode = sessionStorage.getItem('networknode');
        if (networknode)
          xhr.setRequestHeader(
            'X-User-Network-Node-Id',
            `/${smStore.client}/network_nodes/${networknode}`
          );
        const formData = new FormData();
        formData.append('file', file, fileName);
        xhr.send(formData);
        event.stop();
      },
      fileUploadResponse: event => {
        event.stop();
        const { data } = event;
        const { responseText } = event.data.fileLoader.xhr;
        data.url = `${process.env.REACT_APP_API_BASE_URL}/media/${responseText}`;
      },
      ...events,
    }}
    content={content}
  />
);

export default XplorActiveNewsBodyEditor;
